import React from 'react';
import './Input.css';

/**
 * Input component with shadcn-like styling
 */
const Input = React.forwardRef(({
    className = '',
    type = 'text',
    error,
    ...props
}, ref) => {
    const classNames = [
        'input',
        error ? 'input-error' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <input
            ref={ref}
            type={type}
            className={classNames}
            {...props}
        />
    );
});

Input.displayName = 'Input';

/**
 * Label component
 */
const Label = React.forwardRef(({
    className = '',
    children,
    htmlFor,
    required,
    ...props
}, ref) => {
    return (
        <label
            ref={ref}
            htmlFor={htmlFor}
            className={`label ${className}`}
            {...props}
        >
            {children}
            {required && <span className="label-required">*</span>}
        </label>
    );
});

Label.displayName = 'Label';

export { Input, Label };
